(function () {
  'use strict';

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') cents = 0;
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var dollars = parts[0];
    var centsPart = parts[1];

    var withThousands = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if (!format) {
      return 'R$ ' + withThousands + ',' + centsPart;
    }

    return format
      .replace(/\{\{\s*amount\s*\}\}/g, withThousands + ',' + centsPart)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, dollars)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withThousands + ',' + centsPart)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withThousands)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, dollars.replace(/\B(?=(\d{3})+(?!\d))/g, "'") + ',' + centsPart);
  }

  function initWizard(root) {
    var minQuantity = parseInt(root.getAttribute('data-min-quantity'), 10) || 0;
    var minValueCents = parseInt(root.getAttribute('data-min-value-cents'), 10) || 0;
    var moneyFormat = root.getAttribute('data-money-format') || '';
    var discountCode = (root.getAttribute('data-discount') || '').trim();

    var state = {
      step1: [],
      step2: []
    };

    var panels = {
      1: root.querySelector('[data-step-by-step-panel="1"]'),
      2: root.querySelector('[data-step-by-step-panel="2"]')
    };

    var statusEls = {
      1: root.querySelector('[data-step-by-step-status="1"]'),
      2: root.querySelector('[data-step-by-step-status="2"]')
    };

    var summaryLists = {
      1: root.querySelector('[data-step-by-step-summary="1"]'),
      2: root.querySelector('[data-step-by-step-summary="2"]')
    };

    var summaryTotal = root.querySelector('[data-step-by-step-summary-total]');
    var summarySubtotal = root.querySelector('[data-step-by-step-summary-subtotal]');
    var summaryHeaderTotal = root.querySelector('[data-step-by-step-summary-header-total]');
    var summaryToggle = root.querySelector('[data-step-by-step-summary-toggle]');
    var summaryEl = root.querySelector('.step-by-step-wizard__summary');
    var summaryActionBtn = root.querySelector('[data-step-by-step-summary-action]');
    var nextBtn = root.querySelector('[data-step-by-step-next]');
    var backBtn = root.querySelector('[data-step-by-step-back]');
    var checkoutBtn = root.querySelector('[data-step-by-step-checkout]');
    var toast = root.querySelector('[data-step-by-step-toast]');
    var currentStep = 1;

    if (summaryToggle && summaryEl) {
      summaryToggle.addEventListener('click', function () {
        var expanded = summaryEl.classList.toggle('step-by-step-wizard__summary--expanded');
        summaryToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    if (summaryActionBtn) {
      summaryActionBtn.addEventListener('click', function () {
        if (currentStep === 1) {
          var totalQty = state.step1.reduce(function (sum, item) { return sum + item.quantity; }, 0);
          if (totalQty >= minQuantity) showStep(2);
        } else {
          handleCheckout();
        }
      });
    }

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.hidden = false;
      clearTimeout(showToast._timer);
      showToast._timer = setTimeout(function () {
        toast.hidden = true;
      }, 4000);
    }

    function getStep2TotalCents() {
      return state.step2.reduce(function (sum, item) {
        return sum + item.price * item.quantity;
      }, 0);
    }

    function getGrandTotalCents() {
      return getStep2TotalCents();
    }

    function findInState(step, variantId) {
      var list = step === 'step1' ? state.step1 : state.step2;
      return list.findIndex(function (item) {
        return String(item.variantId) === String(variantId);
      });
    }

    function updateSummary() {
      [1, 2].forEach(function (stepNum) {
        var list = summaryLists[stepNum];
        var items = stepNum === 1 ? state.step1 : state.step2;
        if (!list) return;

        list.innerHTML = '';

        if (items.length === 0) {
          if (stepNum === 1) {
            var empty = document.createElement('li');
            empty.className = 'step-by-step-wizard__summary-empty';
            empty.textContent = 'Nenhum produto selecionado.';
            list.appendChild(empty);
          }
          return;
        }

        items.forEach(function (item) {
          var li = document.createElement('li');
          li.className = 'step-by-step-wizard__summary-item';

          var safeTitle = escapeHtml(item.title);
          var imgHtml = item.imageUrl
            ? '<img class="step-by-step-wizard__summary-item-img" src="' + escapeHtml(item.imageUrl) + '" alt="' + safeTitle + '" width="40" height="40" loading="lazy">'
            : '';

          var priceHtml = stepNum === 1
            ? ''
            : '<span class="step-by-step-wizard__summary-item-price">' +
                formatMoney(item.price * item.quantity, moneyFormat) +
              '</span>';

          li.innerHTML =
            imgHtml +
            '<div class="step-by-step-wizard__summary-item-info">' +
              '<span class="step-by-step-wizard__summary-item-title">' + safeTitle + '</span>' +
              '<span class="step-by-step-wizard__summary-item-qty">× ' + item.quantity + '</span>' +
            '</div>' +
            priceHtml;

          list.appendChild(li);
        });
      });

      var grandTotal = formatMoney(getGrandTotalCents(), moneyFormat);
      if (summaryTotal) {
        summaryTotal.textContent = grandTotal;
      }
      if (summarySubtotal) {
        summarySubtotal.textContent = grandTotal;
      }
      if (summaryHeaderTotal) {
        summaryHeaderTotal.textContent = grandTotal;
      }
    }

    function updateStep1Status() {
      var count = state.step1.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      var remaining = Math.max(0, minQuantity - count);
      var el = statusEls[1];

      if (el) {
        if (remaining > 0) {
          el.className = 'step-by-step-wizard__status step-by-step-wizard__status--pending';
          el.textContent =
            remaining === 1
              ? 'Selecione mais 1 item (' + count + ' de ' + minQuantity + ')'
              : 'Selecione mais ' + remaining + ' itens (' + count + ' de ' + minQuantity + ')';
        } else {
          el.className = 'step-by-step-wizard__status step-by-step-wizard__status--done';
          el.textContent = count + ' de ' + minQuantity + ' itens selecionados ✓';
        }
      }

      if (nextBtn) {
        var wasDisabled = nextBtn.disabled;
        nextBtn.disabled = count < minQuantity;
        if (wasDisabled && !nextBtn.disabled) {
          triggerBtnReady(nextBtn);
        }
      }

      if (summaryActionBtn && currentStep === 1) {
        summaryActionBtn.hidden = count < minQuantity;
      }
    }

    function updateStep2Status() {
      var total = getStep2TotalCents();
      var remaining = Math.max(0, minValueCents - total);
      var el = statusEls[2];

      if (el) {
        if (remaining > 0) {
          el.className = 'step-by-step-wizard__status step-by-step-wizard__status--pending';
          el.textContent =
            'Faltam ' +
            formatMoney(remaining, moneyFormat) +
            ' (' +
            formatMoney(total, moneyFormat) +
            ' de ' +
            formatMoney(minValueCents, moneyFormat) +
            ')';
        } else {
          el.className = 'step-by-step-wizard__status step-by-step-wizard__status--done';
          el.textContent =
            '✓ ' +
            formatMoney(total, moneyFormat) +
            ' — meta de ' +
            formatMoney(minValueCents, moneyFormat) +
            ' atingida!';
        }
      }

      if (checkoutBtn) {
        var wasDisabled2 = checkoutBtn.disabled;
        checkoutBtn.disabled = total < minValueCents;
        if (wasDisabled2 && !checkoutBtn.disabled) {
          triggerBtnReady(checkoutBtn);
        }
      }

      if (summaryActionBtn && currentStep === 2) {
        summaryActionBtn.hidden = total < minValueCents;
      }
    }

    function triggerBtnReady(btn) {
      btn.classList.remove('step-by-step-wizard__next--ready');
      /* Force reflow para reiniciar a animação */
      void btn.offsetWidth;
      btn.classList.add('step-by-step-wizard__next--ready');
      btn.addEventListener('animationend', function onEnd() {
        btn.classList.remove('step-by-step-wizard__next--ready');
        btn.removeEventListener('animationend', onEnd);
      });
    }

    function setCardSelected(card, selected) {
      card.classList.toggle('step-by-step-product-card__select--selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    }

    function toggleCard(card) {
      var step = card.getAttribute('data-step');
      var variantId = card.getAttribute('data-variant-id');
      var price = parseInt(card.getAttribute('data-price'), 10) || 0;
      var title = card.getAttribute('data-product-title') || '';
      var imageUrl = card.getAttribute('data-image-url') || '';
      var listKey = step === 'step1' ? 'step1' : 'step2';
      var index = findInState(step, variantId);

      if (index >= 0) {
        state[listKey].splice(index, 1);
        setCardSelected(card, false);
        var display = card.querySelector('.step-by-step-product-card__qty-display');
        if (display) display.textContent = '1';
      } else {
        if (step === 'step1') {
          var currentCount = state.step1.reduce(function (sum, item) { return sum + item.quantity; }, 0);
          if (minQuantity === 1) {
            // Comportamento de rádio: troca a seleção
            if (state.step1.length > 0) {
              var prev = state.step1[0];
              state.step1 = [];
              var prevCard = root.querySelector(
                '[data-step-by-step-card][data-step="step1"][data-variant-id="' + prev.variantId + '"]'
              );
              if (prevCard) setCardSelected(prevCard, false);
            }
          } else if (currentCount >= minQuantity) {
            // Limite atingido — bloqueia nova seleção
            return;
          }
        }
        state[listKey].push({ variantId: variantId, price: price, title: title, imageUrl: imageUrl, quantity: 1 });
        setCardSelected(card, true);
      }

      updateSummary();
      updateStep1Status();
      updateStep2Status();
    }

    function adjustQuantity(card, delta) {
      var step = card.getAttribute('data-step');
      // Bloqueia ajuste de quantidade quando min_quantity=1 na etapa 1
      if (step === 'step1' && minQuantity === 1) return;
      var variantId = card.getAttribute('data-variant-id');
      var listKey = step === 'step1' ? 'step1' : 'step2';
      var index = findInState(step, variantId);
      if (index < 0) return;

      if (delta < 0 && state[listKey][index].quantity === 1) {
        toggleCard(card);
        return;
      }

      if (step === 'step1' && delta > 0) {
        var total1 = state.step1.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        if (total1 >= minQuantity) return; // trava o aumento quando no limite
      }
      state[listKey][index].quantity += delta;

      var display = card.querySelector('.step-by-step-product-card__qty-display');
      if (display) display.textContent = state[listKey][index].quantity;

      updateSummary();
      updateStep1Status();
      updateStep2Status();
    }

    function showStep(stepNum) {
      currentStep = stepNum;

      Object.keys(panels).forEach(function (key) {
        var panel = panels[key];
        var isActive = parseInt(key, 10) === stepNum;
        if (!panel) return;

        panel.classList.toggle('step-by-step-wizard__step--active', isActive);
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (summaryActionBtn) {
        var labelAttr = stepNum === 1 ? 'data-label-step1' : 'data-label-step2';
        summaryActionBtn.textContent = summaryActionBtn.getAttribute(labelAttr) || '';
      }

      if (stepNum === 1) {
        updateStep1Status();
      } else if (stepNum === 2) {
        updateStep2Status();
      }

      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var qtyBtn = event.target.closest('[data-step-by-step-qty]');
      if (qtyBtn) {
        event.preventDefault();
        var card = qtyBtn.closest('[data-step-by-step-card]');
        if (card) {
          var delta = qtyBtn.getAttribute('data-step-by-step-qty') === 'increase' ? 1 : -1;
          adjustQuantity(card, delta);
        }
      }
    });

    root.addEventListener('click', function (event) {
      var qtyBtn = event.target.closest('[data-step-by-step-qty]');
      if (qtyBtn) {
        var card = qtyBtn.closest('[data-step-by-step-card]');
        if (card) {
          var delta = qtyBtn.getAttribute('data-step-by-step-qty') === 'increase' ? 1 : -1;
          adjustQuantity(card, delta);
        }
        return;
      }

      var card = event.target.closest('[data-step-by-step-card]');
      if (card) {
        toggleCard(card);
        return;
      }

      if (event.target.closest('[data-step-by-step-next]')) {
        var totalQty = state.step1.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        if (totalQty >= minQuantity) {
          showStep(2);
        }
        return;
      }

      if (event.target.closest('[data-step-by-step-back]')) {
        showStep(1);
        return;
      }

      if (event.target.closest('[data-step-by-step-checkout]')) {
        handleCheckout();
      }
    });

    function handleCheckout() {
      if (getStep2TotalCents() < minValueCents) return;

      var allItems = state.step1.concat(state.step2).map(function (item) {
        return { id: parseInt(item.variantId, 10), quantity: item.quantity };
      });

      if (allItems.length === 0) return;

      if (checkoutBtn) {
        checkoutBtn.disabled = true;
        checkoutBtn.setAttribute('aria-busy', 'true');
      }
      if (summaryActionBtn) {
        summaryActionBtn.disabled = true;
        summaryActionBtn.setAttribute('aria-busy', 'true');
      }

      fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: allItems })
          });
        })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || data.message || 'Erro ao adicionar ao carrinho');
            });
          }
          var checkoutUrl = '/checkout';
          if (discountCode) {
            checkoutUrl += '?discount=' + encodeURIComponent(discountCode);
          }
          window.location.href = checkoutUrl;
        })
        .catch(function (error) {
          showToast(error.message || 'Não foi possível ir para o checkout. Tente novamente.');
          if (checkoutBtn) {
            checkoutBtn.disabled = getStep2TotalCents() < minValueCents;
            checkoutBtn.removeAttribute('aria-busy');
          }
          if (summaryActionBtn) {
            summaryActionBtn.disabled = false;
            summaryActionBtn.removeAttribute('aria-busy');
            updateStep2Status();
          }
        });
    }

    function initProductFilters() {
      var filtersWrap = root.querySelector('[data-step-by-step-filters]');
      var grid = root.querySelector('[data-step-by-step-grid="2"]');
      if (!filtersWrap || !grid) return;

      var pills = filtersWrap.querySelectorAll('[data-step-by-step-filter-pill]');
      var emptyEl = root.querySelector('[data-step-by-step-filter-empty]');

      function getTitleFromCard(cardLi) {
        var btn = cardLi.querySelector('[data-step-by-step-card]');
        return btn ? btn.getAttribute('data-product-title') || '' : '';
      }

      function resolveKeyword(pillOrValue, explicitKeyword) {
        if (explicitKeyword) return explicitKeyword;
        var v = (pillOrValue || '').trim();
        if (/^kits?$/i.test(v)) return 'kit';
        return v;
      }

      function titleMatches(title, filterValue, keyword) {
        if (filterValue === 'all') return true;
        var kw = resolveKeyword(filterValue, keyword);
        if (!kw) return true;
        return title.toLowerCase().indexOf(kw.toLowerCase()) >= 0;
      }

      function isKitTitle(title) {
        return title.toLowerCase().indexOf('kit') >= 0;
      }

      function setActiveFilter(value) {
        pills.forEach(function (pill) {
          var active = pill.getAttribute('data-filter') === value;
          pill.classList.toggle('is-active', active);
          pill.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function applyFilter(value, keyword) {
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.step-by-step-product-card'));
        var visible = [];

        cards.forEach(function (li) {
          var title = getTitleFromCard(li);
          var show = titleMatches(title, value, keyword);
          li.hidden = !show;
          if (show) {
            visible.push({ li: li, kit: isKitTitle(title) });
          }
        });

        if (/^kits?$/i.test(value) && visible.length > 1) {
          visible.sort(function (a, b) {
            if (a.kit && !b.kit) return -1;
            if (!a.kit && b.kit) return 1;
            return 0;
          });
          visible.forEach(function (item) {
            grid.appendChild(item.li);
          });
        }

        if (emptyEl) {
          emptyEl.hidden = visible.length > 0;
        }

        setActiveFilter(value);
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          applyFilter(
            pill.getAttribute('data-filter'),
            pill.getAttribute('data-filter-keyword')
          );
        });
      });

      applyFilter('all', null);
    }

    initProductFilters();

    updateSummary();
    updateStep1Status();
    updateStep2Status();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-step-by-step-wizard]').forEach(initWizard);
  });
})();
